module.exports = "/_next/static/images/c34a06ba9d65e369a7aecdf2cbb6fd74-mgm-xs-2x.jpg";